import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Los-Angeles.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Maximizing Customer Engagement with Mobile Apps in Los Angeles
            </h2>
            <p>
              Mobile apps have emerged as powerful tools to connect with your
              audience, and TekRevol is your trusted partner in achieving this
              goal. Our mobile app development services in Los Angeles are
              meticulously designed to enhance customer engagement. We
              understand that in a city as diverse as LA, catering to the unique
              needs of your audience is paramount. With custom-tailored mobile
              apps, we create experiences that resonate with your customers,
              fostering loyalty and driving brand advocacy.
            </p>
            <p>
              TekRevol's expert team leverages the latest technologies to craft
              mobile apps that deliver seamless performance, captivating design,
              and user-friendly interfaces.
            </p>
            <p>
              From concept to launch, we ensure your app captivates users and
              encourages interaction, whether you're in e-commerce,
              entertainment, healthcare, or any other industry.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
